import { USER_ROLES } from '../../auth/index';
import { LAYOUT_VALUES } from '../enums';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
	USER_ROLES.LANGOPS,
	USER_ROLES.ADMIN,
];

export default {
	PIPELINES: {
		ACTIVE: true,
		NAME: 'manage-pipelines',
		LABEL: 'Pipelines',
		ICON: 'unbabel-pipeline',
		PATH: '/pipeline-groups/:section',
		CHILDREN: [
			'PIPELINES_GROUPS_LIST',
			'PIPELINES_GROUP_DETAILS',
			'PIPELINES_PIPELINE_DETAILS',
			'PIPELINES_PIPELINE_BUILDER_OLD',
			'PIPELINES_PIPELINE_BUILDER',
			'PIPELINES_PIPELINE_TEST',
		],
		DISPLAY_CHILDREN: false,
		PERMISSIONS,
	},

	PIPELINES_GROUPS_LIST: {
		ACTIVE: true,
		NAME: 'pipelines-groups-list',
		LABEL: 'Pipeline Groups List',
		PARAMS: {
			section: 'list',
		},
		PERMISSIONS,
	},
	PIPELINES_GROUP_DETAILS: {
		ACTIVE: true,
		NAME: 'pipelines-group-details',
		LABEL: 'Pipeline Group Details',
		PARAMS: {
			section: ':pipelineGroupID',
		},
		PERMISSIONS,
	},
	PIPELINES_PIPELINE_TEST: {
		ACTIVE: true,
		NAME: 'pipeline-test',
		LABEL: 'Pipeline Testing',
		PARAMS: {
			section: ':pipelineGroupID/test',
		},
		PERMISSIONS,
	},
	PIPELINES_PIPELINE_DETAILS: {
		ACTIVE: true,
		NAME: 'pipeline-details',
		LABEL: 'Pipeline Details',
		PARAMS: {
			section: ':pipelineGroupID/pipeline/:pipelineID',
		},
		PERMISSIONS,
	},
	PIPELINES_PIPELINE_BUILDER_OLD: {
		ACTIVE: true,
		NAME: 'pipeline-builder-old',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		LABEL: 'Pipeline Builder',
		PARAMS: {
			section: ':pipelineGroupID/pipeline/:pipelineID/edit',
		},
		PERMISSIONS,
	},
	PIPELINES_PIPELINE_BUILDER: {
		ACTIVE: true,
		NAME: 'pipeline-builder',
		LAYOUT: LAYOUT_VALUES.FULLSCREEN,
		LABEL: 'Pipeline Builder',
		PARAMS: {
			section: ':pipelineGroupID/canvas',
		},
		PERMISSIONS,
	},
};
